import { inject, Injectable, signal } from '@angular/core';
import type { IRequestDTask } from '@rdlabo/odss-mobile-hono/src/api/functions/task/api';
import type { ITransaction } from '../interfaces';
import { ViewModelStore as BaseViewModelStore } from '../../../shared/src/lib/store.model';
import { UserStatusStore } from '../reducer';

export const transactionDefault = (): ITransaction => ({
  slipType: 0,
  pickupItems: [],
});

export const taskDefault = (): IRequestDTask => ({
  attachments: [],
  slipIds: [],
  memo: null,
  mapUrl: null,
  classification: 301,
});

@Injectable({ providedIn: 'root' })
export class SharedState {
  readonly #transaction = signal<ITransaction>(transactionDefault());
  readonly #task = signal<IRequestDTask>(taskDefault());
  readonly transaction = this.#transaction.asReadonly();
  readonly task = this.#task.asReadonly();

  setTransaction(transaction: ITransaction): void {
    this.#transaction.set(transaction);
  }

  setTask(task: IRequestDTask): void {
    this.#task.set(task);
  }
}

export abstract class ViewModelStore<T, K extends keyof T = never> extends BaseViewModelStore<T, K> {
  readonly #state = inject(SharedState);
  readonly #userStatus = inject(UserStatusStore);
  readonly transaction = this.#state.transaction;
  readonly task = this.#state.task;
  readonly status = this.#userStatus.statusSignal;

  setTransaction(transaction: ITransaction): void {
    this.#state.setTransaction(transaction);
  }

  setTask(task: IRequestDTask): void {
    this.#state.setTask(task);
  }

  setUserStatus(status: Parameters<UserStatusStore['setUserStatus']>[0]): void {
    this.#userStatus.setUserStatus(status);
  }
}
